module.exports = "<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\"\n    uib-modal-animation-class=\"fade\"\n    modal-in-class=\"in\"\n    ng-style=\"{'z-index': 1050 + index*10, display: 'block'}\">\n    <div class=\"modal-dialog alert\" ng-class=\"{'modal-small': size == 'sm', 'modal-large': size == 'lg'}\" uib-modal-transclude></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/dc-ui/dc-modal/windowTemplateError.tpl.html
// module id = 937
// module chunks = 12